import {showSnackbar, SnackbarType} from 'webapp-lib/Functions';

import i18n from '_/i18n';
import {CasusReadonlyReason} from '_/types/casus';

export function showCasusReadonlyWarningSnackbar(
  readonlyReason: CasusReadonlyReason
): void {
  showSnackbar({
    text: getCasusReadonlyReasonText(readonlyReason),
    type: SnackbarType.WARNING,
    override: {
      id: 'CasusLockedCondition',
      mode: 'REPLACE',
    },
  });
}

export function getCasusReadonlyReasonText(
  casusReadonlyReason: CasusReadonlyReason
): string {
  switch (casusReadonlyReason) {
    case CasusReadonlyReason.LOCKED:
      return i18n.t('casus:casusLocked.explicitly');
    case CasusReadonlyReason.ARCHIVED:
      return i18n.t('casus:casusLocked.archived');
  }
}
